import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export function getInternalPermissions() {
  return request(`${ROOT_SERVER_URL}/api/internal-permissions`);
}
